import React from 'react';
import Navbar from '../../components/navbar/Navbar';
import Footer from '../../components/footer/Footer';
import Container from '../../components/Container';
import PageHeader from '../../components/PageHeader';
import Prose from '../../components/Prose';

const AccessibilityPage = () => {
  return (
    <div className="min-h-screen bg-[#f8f8f8]">
      <Navbar />
      
      <Container size="md">
        <PageHeader
          eyebrow="Legal"
          title="Accessibility Statement"
          description="Our commitment to making our website accessible to everyone."
        />
        
        <div className="pb-16">
          <Prose>
            <h2>Our Commitment</h2>
            <p>
              Radiance is committed to ensuring digital accessibility for people with disabilities. 
              We are continually improving the user experience for everyone and applying the 
              relevant accessibility standards.
            </p>

            <h2>Accessibility Standards</h2>
            <p>
              We strive to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA 
              standards and comply with the Accessibility for Ontarians with Disabilities Act (AODA) 
              requirements.
            </p>

            <h2>Accessibility Features</h2>
            <p>
              Our website includes the following accessibility features:
            </p>
            <ul>
              <li><strong>Keyboard Navigation:</strong> All interactive elements can be accessed using a keyboard</li>
              <li><strong>Screen Reader Support:</strong> Proper heading structure and alt text for images</li>
              <li><strong>Color Contrast:</strong> Text meets WCAG color contrast requirements</li>
              <li><strong>Resizable Text:</strong> Text can be enlarged up to 200% without loss of functionality</li>
            </ul>

            <h2>Feedback and Assistance</h2>
            <p>
              We welcome your feedback on the accessibility of our website. If you encounter 
              accessibility barriers or need assistance accessing any content, please contact us:
            </p>
            <ul>
              <li><strong>Email:</strong> <a href="mailto:accessibility@myradiance.ca">accessibility@myradiance.ca</a></li>
            </ul>
          </Prose>
        </div>
      </Container>
      
      <Footer />
    </div>
  );
};

export default AccessibilityPage;
